import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/home/runner/work/openeo-vue-components/openeo-vue-components/node_modules/css-loader/dist/runtime/api.js'
import '/home/runner/work/openeo-vue-components/openeo-vue-components/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/home/runner/work/openeo-vue-components/openeo-vue-components/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('openeo-billing-plans', wrap(Vue, () => import('~root/./components/BillingPlans.vue?shadow')))

window.customElements.define('openeo-capabilities', wrap(Vue, () => import('~root/./components/Capabilities.vue?shadow')))

window.customElements.define('openeo-collection', wrap(Vue, () => import('~root/./components/Collection.vue?shadow')))

window.customElements.define('openeo-collections', wrap(Vue, () => import('~root/./components/Collections.vue?shadow')))

window.customElements.define('openeo-data-table', wrap(Vue, () => import('~root/./components/DataTable.vue?shadow')))

window.customElements.define('openeo-deprecation-notice', wrap(Vue, () => import('~root/./components/DeprecationNotice.vue?shadow')))

window.customElements.define('openeo-description', wrap(Vue, () => import('~root/./components/Description.vue?shadow')))

window.customElements.define('openeo-experimental-notice', wrap(Vue, () => import('~root/./components/ExperimentalNotice.vue?shadow')))

window.customElements.define('openeo-federation-missing-notice', wrap(Vue, () => import('~root/./components/FederationMissingNotice.vue?shadow')))

window.customElements.define('openeo-file-format', wrap(Vue, () => import('~root/./components/FileFormat.vue?shadow')))

window.customElements.define('openeo-file-formats', wrap(Vue, () => import('~root/./components/FileFormats.vue?shadow')))

window.customElements.define('openeo-item', wrap(Vue, () => import('~root/./components/Item.vue?shadow')))

window.customElements.define('openeo-items', wrap(Vue, () => import('~root/./components/Items.vue?shadow')))

window.customElements.define('openeo-job', wrap(Vue, () => import('~root/./components/Job.vue?shadow')))

window.customElements.define('openeo-job-estimate', wrap(Vue, () => import('~root/./components/JobEstimate.vue?shadow')))

window.customElements.define('openeo-json-schema', wrap(Vue, () => import('~root/./components/JsonSchema.vue?shadow')))

window.customElements.define('openeo-link-list', wrap(Vue, () => import('~root/./components/LinkList.vue?shadow')))

window.customElements.define('openeo-logs', wrap(Vue, () => import('~root/./components/Logs.vue?shadow')))

window.customElements.define('openeo-model-builder', wrap(Vue, () => import('~root/./components/ModelBuilder.vue?shadow')))

window.customElements.define('openeo-object-tree', wrap(Vue, () => import('~root/./components/ObjectTree.vue?shadow')))

window.customElements.define('openeo-process', wrap(Vue, () => import('~root/./components/Process.vue?shadow')))

window.customElements.define('openeo-processes', wrap(Vue, () => import('~root/./components/Processes.vue?shadow')))

window.customElements.define('openeo-processing-parameters', wrap(Vue, () => import('~root/./components/ProcessingParameters.vue?shadow')))

window.customElements.define('openeo-search-box', wrap(Vue, () => import('~root/./components/SearchBox.vue?shadow')))

window.customElements.define('openeo-searchable-list', wrap(Vue, () => import('~root/./components/SearchableList.vue?shadow')))

window.customElements.define('openeo-service', wrap(Vue, () => import('~root/./components/Service.vue?shadow')))

window.customElements.define('openeo-service-type', wrap(Vue, () => import('~root/./components/ServiceType.vue?shadow')))

window.customElements.define('openeo-service-types', wrap(Vue, () => import('~root/./components/ServiceTypes.vue?shadow')))

window.customElements.define('openeo-stac', wrap(Vue, () => import('~root/./components/Stac.vue?shadow')))

window.customElements.define('openeo-supported-features', wrap(Vue, () => import('~root/./components/SupportedFeatures.vue?shadow')))

window.customElements.define('openeo-tab', wrap(Vue, () => import('~root/./components/Tab.vue?shadow')))

window.customElements.define('openeo-tabs', wrap(Vue, () => import('~root/./components/Tabs.vue?shadow')))

window.customElements.define('openeo-udf-runtime', wrap(Vue, () => import('~root/./components/UdfRuntime.vue?shadow')))

window.customElements.define('openeo-udf-runtimes', wrap(Vue, () => import('~root/./components/UdfRuntimes.vue?shadow')))